<template>
  <b-input-group 
    size="sm"
  >
    <b-input-group-prepend  
      is-text
    >
      €
    </b-input-group-prepend>
    <b-form-input 
      v-model.number="value[field]"
      :disabled="disabled" 
      type="number" 
      @input="validateInput"
    />
    <!-- <b-input-group-append 
      is-text 
    >
    <small >.00</small></b-input-group-append> -->
  </b-input-group>
</template>
<script>
export default {
    name: 'FinancieelInput',
    components: {},
    mixins: [],
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        field: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return  {
        }
    },
    computed: {},
    watch: {},
    mounted () {
        
    },
    methods: {
        // validate input
        validateInput() {
            if (this.value[this.field] < 0) {
                this.value[this.field] = 0;
            }
            // if empty string then null
            if (this.value[this.field] === '') {
                this.value[this.field] = null;
            }
        }
    },
          
}
</script>